import { render, staticRenderFns } from "./title-english.vue?vue&type=template&id=0661a694&scoped=true"
import script from "./title-english.vue?vue&type=script&lang=js"
export * from "./title-english.vue?vue&type=script&lang=js"
import style0 from "./title-english.vue?vue&type=style&index=0&id=0661a694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0661a694",
  null
  
)

export default component.exports